export function STDStatusList() {
    let StatusList= [{
                value:'4',
                label: 'Accidental Damage'
              }, {
                value: '6',
                label: 'Damage due to Rain'
              }, {
                value: '5',
                label: 'Fragile Items'
              }, {
                value: '3',
                label: 'Improper Handling'
              }, {
                value: '1',
                label: 'Liquid Spillage'
              }, {
                value: '7',
                label: 'Natural Calamity'
              }, {
                value: '8',
                label: 'Pilferage'
              }, {
                value: '2',
                label: 'Poor Packaging'
              }]
    return StatusList;
  }
  export function STDBagconditionList() {
    let BagConditionList =[{
        value: "Intact",
        label: 'Intact'
    }, {
        value: "Torn/Damage",
        label: 'Torn/Damage'
    }, {
        value: "WithoutSeal",
        label: 'WithoutSeal'
    }]
    return BagConditionList;
  }


// WEBPACK FOOTER //
// ./src/services/STDBagConditionList.js